/**
 * External Dependencies
 */
import 'jquery';
// import { jsPDF } from 'jspdf';
// import html2canvas from 'html2canvas';

$(document).ready(() => {
  // const $brandSubPrint = $('[data-brandsub-pdf]');
  
  // $brandSubPrint.on('click', (e) => {
  //   e.preventDefault();

  //   $('svg').each(function() {
  //     const $el = $(this);

  //     $el.attr('width', $el[0].getBoundingClientRect().width);
  //     $el.attr('height', $el[0].getBoundingClientRect().height);
  //   });

  //   $('.fill-current').each(function() {
  //     const $el = $(this);

  //     $el.attr('fill', $el.css('color'));
  //     $el.css('fill', $el.css('color'));
  //     $el.removeClass('fill-current');
  //   });

  //   $('.stroke-current').each(function() {
  //     const $el = $(this);

  //     $el.attr('stroke', $el.css('color'));
  //     $el.css('stroke', $el.css('color'));
  //     $el.removeClass('stroke-current');
  //   });

  //   const element = document.getElementById('brand-sub');

  //   html2canvas(element, {
  //     useCORS: true,
  //     imageTimeout: 0,
  //     allowTaint: false,
  //   }).then(function(canvas) {
  //     const imgData = canvas.toDataURL('image/png');
  //     const pdf = new jsPDF({
  //       orientation: 'landscape',
  //     });
  //     const imgProps= pdf.getImageProperties(imgData);
  //     const pdfWidth = pdf.internal.pageSize.getWidth();
  //     const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
  //     pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
  //     pdf.save('download.pdf');
  //   });
  // });
});
